import { Component } from '@angular/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { UiModule } from '../../../../components/ui.module';
import { ApiKey } from '../../../../types/api-keys';

type CellParams = ICellRendererParams<ApiKey> & {
  toggleCallback: (key: ApiKey) => void;
  editCallback: (key: ApiKey) => void;
};

@Component({
  selector: 'app-pan-cell-apikey-actions',
  imports: [UiModule, MatTooltipModule, RouterModule],
  templateUrl: './cell-apikey-actions.component.html',
  styleUrl: './cell-apikey-actions.component.scss',
})
export class CellApikeyActionsComponent implements ICellRendererAngularComp {
  public params!: CellParams;

  agInit(params: CellParams) {
    this.params = params;
  }

  refresh(params: CellParams) {
    this.params = params;
    return true;
  }
}
